





















































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import CAlertCircle from '~/components/shared/configurable/CAlertCircle.vue'
import { Trigger } from '~/models/app/trigger'
import { Position } from '~/models/app/position'
import { Variant } from '~/models/app/variant'
import { Distance } from '~/models/dropdown/distance'
import { ciTradesMatch } from '~/icons/source/regular/trades-match'
import { ciEnvelope } from '~/icons/source/regular/envelope'
import { TradesNotifications } from '~/models/trades/types'
import { ciTradesLikes } from '~/icons/source/regular/trades-likes'

export default defineComponent({
  props: {
    notifications: {
      type: Object as PropType<TradesNotifications>,
      required: true
    },
    diameter: { type: [Number, String], default: 14, required: false },
    circleClasses: { type: String, required: false, default: '' }
  },
  components: { CAlertCircle },
  setup() {
    const trigger = computed(() => Trigger)
    const position = computed(() => Position)
    const variant = computed(() => Variant)
    const distance = computed(() => Distance)
    return {
      trigger,
      position,
      variant,
      distance,
      ciTradesMatch,
      ciTradesLikes,
      ciEnvelope
    }
  }
})
